var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 490,
    height: 490
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.34 57.4c-16.48-14.81-41.85-13.46-56.66 3.02l-.02.02c-14.79 16.54-13.41 41.94 3.09 56.79 6.58 5.91 39.48 35.44 98.7 88.61H42.98C20.81 205.85.47 223.83.47 246c0 22.17 20.34 40.15 42.51 40.17h301.75c-61.2 51.48-95.21 80.08-102.01 85.8a40.045 40.045 0 00-14.31 30.79c-.01 22.15 17.95 40.12 40.11 40.12 9.45 0 18.59-3.33 25.82-9.41 18.14-15.25 163.21-137.26 181.34-152.51 8.92-7.5 14.14-18.5 14.32-30.15-.61-12.2-4.67-22.75-13.33-30.53C440.41 187.7 313.48 73.69 295.34 57.4z"
  })));
}
export default SvgArrowRight;